module.exports = __webpack_public_path__ + "static/media/Kepler Farm.809873ec.jpg";